// Highcharts initialisation — shared by legacy platform AND ActiveAdmin.
//
// window.Highcharts is required by:
//   - modules/v4/bids_charts/ (bids analysis charts)
//   - modules/v4/product_approval_charts/ (product approval charts)
//   - modules/v4/project_charts/ (project breakdown charts)
//   - modules/charts/project/event_chart.js (project Gantt chart)
//   - modules/dashboards/profile/ (timeline/pie dashboard charts)
//   - ActiveAdmin views via Chartkick
//
// Exporting plugins are loaded with a .default || fn guard because
// esbuild resolves highcharts module plugins differently in IIFE vs ESM format.

import Highcharts from 'highcharts';
import _Exporting from 'highcharts/modules/exporting';
import _OfflineExporting from 'highcharts/modules/offline-exporting';
import _ExportData from 'highcharts/modules/export-data';

// Highcharts module plugins export a function in ESM, but esbuild may wrap
// them as { default: fn } when bundling to IIFE — guard both cases.
function initHCModule(mod) {
    var fn = (mod && mod.default) ? mod.default : mod;
    if (typeof fn === 'function') { fn(Highcharts); }
}

initHCModule(_Exporting);
initHCModule(_OfflineExporting);
initHCModule(_ExportData);

Highcharts.setOptions({
    lang: { thousandsSep: ',' }
});

window.Highcharts = Highcharts;
